import React, { Component, PropTypes } from 'react';
import { Menu, Icon, Table, Button, Modal, Row, Col, Spin, Input, Form, Pagination, Checkbox } from 'antd';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import cn from 'classnames';
import { formItemLayout } from 'constants/layout';

import { connect } from 'react-redux';
// import { getUsers, activeArticle, recommendArticle, unrecommendArticle, deleteArticle } from 'redux/modules/class';
import { getUsers, addAdmin, updatePermissions, deleteAdmin } from 'data/user';

import Utils from 'utils/utils';

import classes from '../styles/AdminList.module.scss';
import moment from 'moment';

const pageLimit = 20;
const Confirm = Modal.confirm;
const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;

const permissions = [
  { label: 'Admin', value: 'admin' },
  { label: 'Content', value: 'content' },
  { label: 'User', value: 'user' },
  { label: 'Withdraw', value: 'withdraw' },
  { label: 'Class', value: 'class' },
  { label: 'Space', value: 'space' },
  { label: 'Dashboard', value: 'dashboard' },
  { label: 'Order', value: 'order' },
];

class AdminList extends Component {
  constructor(props) {
    super(props);
    this.onClickRow = this.onClickRow.bind(this);
    this.changeFocusPage = this.changeFocusPage.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onInputSearch = this.onInputSearch.bind(this);
    this.onSearchInputPress = this.onSearchInputPress.bind(this);

    this.onOpenAddAdminModal = this.onOpenAddAdminModal.bind(this);
    this.onOpenPermissionModal = this.onOpenPermissionModal.bind(this);
    this.handleAddAdmin = this.handleAddAdmin.bind(this);
    this.handleEditPermissions = this.handleEditPermissions.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.state = {
      collapseMobile: [],
      showAddAdminModal: false,
      showPermissionModal: false,
      searchBy: 'all',
      page: props.page,
      displaySearchValue: '',
      searchValue: '',
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: false });
    const users = await getUsers({ role: 'admin' });
    this.setState({ users: users.results, loading: true, page: users.page, count: users.count });
  };

  componentWillMount() {
    this.setState({
      showAddAdminModal: false,
    });
  }

  getUsers = async (query) => {
    this.setState({ loading: false });
    const users = await getUsers({ query, role: 'admin' });
    this.setState({ users: users.results, loading: true, page: users.page, count: users.count });
  };

  onClickRow(record, index, event) {
    console.log(record, index);
    event.preventDefault();
    console.log('row click');
    this.onOpenPermissionModal(record);

    // browserHistory.push(`/class/${record.slug}`);
  }

  onChangePage(page) {
    this.setState(
      {
        page: page,
      },
      () => {
        this.getUsers(_.merge(this.getCurrentQuery(), { page }));
      },
    );
  }

  onDelete(record) {
    // const type = record.subcategories ? 'category' : 'subcategory';

    deleteAdmin(record._id).then(() => {
      this.getUsers(this.getCurrentQuery());
    });
    // }).catch((err) => {
    //   message.error(err.message);
    // });
  }

  onSearch() {
    console.log(this.state.searchBy);
    this.getUsers(_.merge(this.getCurrentQuery(), { q: this.state.displaySearchValue })).then((response) => {
      console.log(response);
    });
    this.setState({
      page: 1,
      searchValue: this.state.displaySearchValue,
    });
  }

  onInputSearch(event) {
    this.setState({
      displaySearchValue: event.target.value,
    });
  }

  onSearchInputPress(event) {
    if (event.charCode === 13) {
      this.onSearch();
    }
  }

  onOpenAddAdminModal() {
    this.setState({
      showAddAdminModal: true,
      showPermissionModal: false,
    });
  }

  onOpenPermissionModal(row) {
    this.setState({
      showAddAdminModal: false,
      showPermissionModal: true,
      selectedRow: row,
    });
  }

  getCurrentQuery() {
    return {
      page: this.state.page,
      searchBy: this.state.searchBy,
      q: this.state.searchValue,
      role: 'admin',
      sortBy: this.state.sortBy,
    };
  }

  handleAddAdmin(e) {
    e.preventDefault();
    const _getUsers = this.getUsers;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        console.log(values);

        addAdmin({
          email: values.email,
        }).then(async () => {
          await _getUsers(this.getCurrentQuery());
          this.setState({
            showAddAdminModal: false,
          });
        });
        console.log('Received values of form: ', values);
      }
    });
  }

  handleEditPermissions(e) {
    e.preventDefault();
    const _getUsers = this.getUsers;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        console.log(values);
        updatePermissions({
          permissions: values.permissions,
          userId: values._id,
        }).then(async () => {
          await _getUsers(this.getCurrentQuery());
          this.setState({
            showPermissionModal: false,
          });
        });
        console.log('Received values of form: ', values);
      }
    });
  }

  handleCancel() {
    this.setState({
      showAddAdminModal: false,
      showPermissionModal: false,
      selectedRow: null,
      isAddNew: false,
      confirmDirty: false,
      getFieldDecorator: false,
      showNewPageModal: false,
    });
  }

  changeFocusPage(event) {
    const searchBy = event.key;
    this.getUsers(_.merge(this.getCurrentQuery(), { searchBy, page: 1 })).then((response) => {
      console.log(response);
    });
    this.setState({
      searchBy,
    });
  }

  showDeleteConfirm(record, msg, content) {
    console.log('confirm');
    Confirm({
      title: msg,
      content: content || '',
      onOk: () => this.onDelete(record),
      onCancel: this.onCancel,
    });
    this.setState({ showPermissionModal: false });
  }

  columns = [
    {
      title: 'ชื่อ',
      dataIndex: 'name',
      render: (value, record) => <div>{`${value.first}  ${value.last}`}</div>,
    },
    {
      title: 'อีเมลล์',
      dataIndex: 'email',
    },
    {
      title: 'สิทธิการใช้งาน',
      dataIndex: 'studentCount',
      render: (value) => _.startCase(value),
    },
    {
      title: '',
      dataIndex: '_id',
      render: (value, record) => {
        return (
          <div>
            <Button
              type="danger"
              onClick={(e) => {
                e.stopPropagation();
                this.showDeleteConfirm(record, `ยืนยันการลบ ${record.title}`);
              }}
            >
              ลบออกจากแอดมิน
            </Button>
            &nbsp;
          </div>
        );
      },
    },
  ];

  renderContentTable() {
    const content = _.map(this.state.users, (singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    return (
      <div>
        <Table columns={this.columns} dataSource={content} bordered pagination={false} onRowClick={this.onClickRow} />
        <Pagination className={cn(classes.pagination, 'text-right')} current={this.state.page} onChange={this.onChangePage} defaultPageSize={pageLimit} total={this.state.count} />
      </div>
    );
  }

  renderAddAdminModal() {
    const { getFieldDecorator } = this.props.form;
    if (!this.state.showAddAdminModal) {
      return <div />;
    }
    return (
      <Modal
        title={'New page'}
        visible={this.state.showAddAdminModal}
        onCancel={this.handleCancel}
        footer={[
          <Button key="back" size="large" onClick={this.handleCancel}>
            ยกเลิก
          </Button>,
          <Button key="submit" type="primary" size="large" onClick={this.handleAddAdmin}>
            เพิ่มอีเมลล์นี้เป็นแอดมิน
          </Button>,
        ]}
      >
        <Form onSubmit={this.handleSubmitNewPage}>
          <FormItem {...formItemLayout} label="อีเมลล์" hasFeedback>
            {getFieldDecorator('email', {
              rules: [
                {
                  type: 'email',
                  required: true,
                  message: 'โปรดใส่อีเมลล์ให้ถูกต้อง',
                },
              ],
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }

  renderPermissionModal() {
    const { getFieldDecorator } = this.props.form;
    if (!this.state.showPermissionModal) {
      return <div />;
    }
    const initPermissions = _.get(this, 'state.selectedRow.permissions');
    return (
      <Modal
        title={'New page'}
        visible={this.state.showPermissionModal}
        onCancel={this.handleCancel}
        footer={[
          <Button key="back" size="large" onClick={this.handleCancel}>
            ยกเลิก
          </Button>,
          <Button key="submit" type="primary" size="large" onClick={this.handleEditPermissions}>
            แก้ไขสิทธิ์
          </Button>,
        ]}
      >
        <Form onSubmit={this.handleSubmitNewPage}>
          <FormItem {...formItemLayout} label="ชื่อ" hasFeedback>
            <div>{`${this.state.selectedRow.name.first} ${this.state.selectedRow.name.last}`}</div>
          </FormItem>
          <FormItem {...formItemLayout} label="อีเมลล์">
            <div>{this.state.selectedRow.email}</div>
          </FormItem>
          <FormItem {...formItemLayout} label="สิทธิการใช้งาน" hasFeedback>
            {getFieldDecorator('permissions', { initialValue: initPermissions })(<CheckboxGroup options={permissions} defaultValue={initPermissions} />)}
          </FormItem>
          <FormItem>
            {getFieldDecorator('_id', {
              initialValue: this.state.selectedRow._id,
            })(<Input type="hidden" />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }

  render() {
    return (
      <div>
        <div className="page-header">{this.props.BreadCrumb}</div>
        <div className="content">
          <div className="text-right">
            <Button type="primary" size="large" onClick={this.onOpenAddAdminModal}>
              <Icon type="plus" />
              <span>เพิ่มแอดมิน</span>
            </Button>
          </div>
          <div className={classes.searchContainer}>
            <Input prefix={<Icon type="search" />} placeholder="พิมพ์คำที่ต้องการค้นหา" onKeyPress={(e) => this.onSearchInputPress(e)} onChange={(e) => this.onInputSearch(e)} />
          </div>
          {this.renderContentTable()}
          {this.renderAddAdminModal()}
          {this.renderPermissionModal()}
        </div>
      </div>
    );
  }
}
export default Form.create()(AdminList);
